import {
    RESTORE_PERSISTED_STATE,
    REFRESH_PERSISTED_STATE
    } from '../actions/actionTypes'

import objectPath from 'object-path'

export default function reducer(state={}, action)
{
    let stateCopy;
    switch(action.type)
    {
        case RESTORE_PERSISTED_STATE:
            let persistedState = action.payload;
            stateCopy = Object.assign({}, state);

            Object.keys(persistedState).forEach((item) => {
                objectPath.set(stateCopy, item, persistedState[item]);
            });

            return stateCopy;
        case REFRESH_PERSISTED_STATE:
            let stateLoc = action.payload.stateLocation;
            let value = action.payload.value;
            stateCopy = Object.assign({}, state);

            objectPath.set(stateCopy, stateLoc, value );
            return stateCopy;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence-strategy-cookie/src/reducers/index.js